import { cn } from '@/lib/utils'
import { Icon } from '@/ui/components'

interface CheckboxProps extends React.ComponentProps<'input'> {
  label: string
  description?: string
  id?: string
  onClick?: () => void
  containerClassName?: string
}

const Checkbox = ({
  label,
  id,
  description,
  onClick,
  className,
  containerClassName,
  onChange,
  ...props
}: CheckboxProps) => {
  const isControlled = 'checked' in props
  const hasChangeHandler = onChange ?? onClick
  const effectiveOnChange = onChange ?? (onClick ? () => onClick() : undefined)
  const readOnly = isControlled && !hasChangeHandler

  return (
    <div className={cn('gap-xs flex items-start', containerClassName)}>
      <div className="peer relative size-6">
        <input
          type="checkbox"
          id={id}
          className={cn(
            'global-focus easing-none rounded-0! m-0! size-6 shrink-0 cursor-pointer appearance-none border border-neutral-400 bg-white accent-neutral-600 outline-none hover:border-2 hover:border-neutral-600',
            'checked:border-neutral-600 checked:bg-neutral-600',
            className
          )}
          {...props}
          onChange={effectiveOnChange}
          onClick={onClick}
          readOnly={readOnly}
        />

        <div className="pointer-events-none absolute inset-0 flex items-center justify-center text-neutral-100">
          <Icon icon="mdi:check" className="size-5" />
        </div>
      </div>

      <div className="gap-xs grid">
        <label
          className="cursor-pointer [&_a]:underline [&_a]:hover:no-underline"
          htmlFor={id}
          dangerouslySetInnerHTML={{ __html: label }}
        />
        {description && <p>{description}</p>}
      </div>
    </div>
  )
}

Checkbox.displayName = 'Checkbox'

export default Checkbox
